<div class="pdf-viewer-popup">
  <div class="modal-content">
    <div class="modal-title-bg text-left">
      <div class="col float-left ml-4 mt-1">
        <h2 class="text-white">{{ title }}</h2>
      </div>
      <div class="col float-right mr-5" style="margin-left: 97.5%;margin-top: -40px;">
        <button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="pdf-viewer-body">
    @if (displayPDF) {
      <ngx-extended-pdf-viewer
        [src]="pdfData"
        [showOpenFileButton]="false"
        [useBrowserLocale]="true"
        [textLayer]="true"
        [showPresentationModeButton]="true"
        [filenameForDownload]="downloadFileName"
        [showBookmarkButton]="false"
        [showRotateButton]="false"
        [showEditorButtons]="false"
        [showDrawEditor]="false"
        [showTextEditor]="false"
        [showStampEditor]="false"
        [showHighlightEditor]="false"
        [showCommentEditor]="false"
        [showSignatureEditor]="false"
        [(page)]="page"
        [(pageLabel)]="pageLabel"
        [minifiedJSLibraries]="false"
        (beforePrint)="beforePrint()">
      </ngx-extended-pdf-viewer>
    }
    @if (!displayPDF) {
      <ng2-pdfjs-viewer
        [pdfSrc]="pdfData"
        [zoom]="zoom"
        [downloadFileName]="downloadFileName"
        [openFile]="false"
        [download]="downLoadFile"
        [viewBookmark]="false"
        viewerId="hdmpdfViewer"
        (onBeforePrint)="beforePrint()"
        (onAfterPrint)="afterPrint()">
      </ng2-pdfjs-viewer>
    }
  </div>
</div>
